import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { COMMON_TRANSLATION } from '@/common/constants';
import { getSelectedDateRangeString } from '@/common/utils';
import { StyledDate, StyledSelectedRange } from './DateRangeText.styles';
import { DateRangeTextProps } from './DateRangeText.types';

const DateRangeText: FC<DateRangeTextProps> = ({ css, startDate, endDate }) => {
  const { t } = useTranslation([COMMON_TRANSLATION]);

  const getSelectedData = (): string => {
    return startDate === undefined || endDate === undefined
      ? t('date_range_dropdown_options.all_time')
      : getSelectedDateRangeString(startDate, endDate);
  };

  return (
    <StyledSelectedRange data-testid="date-range-text" css={{ ...css }}>
      {t('selected_date_range.label')}
      <StyledDate data-testid="date-range-date"> {getSelectedData()} </StyledDate>
    </StyledSelectedRange>
  );
};

export default DateRangeText;
